const ALLOWED_TAGS = new Set([
  'a', 'b', 'blockquote', 'br', 'code', 'del', 'div', 'em', 'h1', 'h2',
  'h3', 'h4', 'h5', 'h6', 'hr', 'i', 'img', 'li', 'ol', 'p', 'pre',
  's', 'span', 'strong', 'table', 'tbody', 'td', 'th', 'thead', 'tr',
  'u', 'ul'
])

const GLOBAL_ATTRIBUTES = new Set(['class', 'title'])
const TAG_ATTRIBUTES = {
  a: new Set(['href', 'rel', 'target']),
  img: new Set(['alt', 'height', 'src', 'width']),
  td: new Set(['colspan', 'rowspan']),
  th: new Set(['colspan', 'rowspan'])
}

const SAFE_URL = /^(?:https?:|mailto:|tel:|#|\?|\/(?!\/)|\.\.?(?:\/|$))/i
const SAFE_IMAGE_DATA_URL = /^data:image\/(?:gif|jpe?g|png|webp);base64,/i

function isSafeUrl(value, allowImageData = false) {
  const normalized = Array.from(String(value || ''))
    .filter((character) => {
      const codePoint = character.charCodeAt(0)
      return codePoint > 0x20 && (codePoint < 0x7f || codePoint > 0x9f)
    })
    .join('')
  return SAFE_URL.test(normalized) || (allowImageData && SAFE_IMAGE_DATA_URL.test(normalized))
}

export function sanitizeRichHtml(value) {
  if (!value) return ''

  const documentValue = new DOMParser().parseFromString(String(value), 'text/html')
  const elements = Array.from(documentValue.body.querySelectorAll('*'))

  for (const element of elements) {
    const tagName = element.tagName.toLowerCase()
    if (!ALLOWED_TAGS.has(tagName)) {
      element.replaceWith(documentValue.createTextNode(element.textContent || ''))
      continue
    }

    const tagAttributes = TAG_ATTRIBUTES[tagName] || new Set()
    for (const attribute of Array.from(element.attributes)) {
      const attributeName = attribute.name.toLowerCase()
      if (!GLOBAL_ATTRIBUTES.has(attributeName) && !tagAttributes.has(attributeName)) {
        element.removeAttribute(attribute.name)
        continue
      }

      if (attributeName === 'href' && !isSafeUrl(attribute.value)) {
        element.removeAttribute(attribute.name)
      }
      if (attributeName === 'src' && !isSafeUrl(attribute.value, tagName === 'img')) {
        element.removeAttribute(attribute.name)
      }
      if (['height', 'width', 'colspan', 'rowspan'].includes(attributeName) &&
          !/^\d{1,4}%?$/.test(attribute.value)) {
        element.removeAttribute(attribute.name)
      }
      if (attributeName === 'target' && !['_blank', '_self'].includes(attribute.value)) {
        element.removeAttribute(attribute.name)
      }
    }

    if (tagName === 'a' && element.getAttribute('target') === '_blank') {
      element.setAttribute('rel', 'noopener noreferrer')
    }
  }

  return documentValue.body.innerHTML
}

export const safeHtmlDirective = {
  beforeMount(element, binding) {
    element.innerHTML = sanitizeRichHtml(binding.value)
  },
  updated(element, binding) {
    if (binding.value !== binding.oldValue) {
      element.innerHTML = sanitizeRichHtml(binding.value)
    }
  }
}
